module.exports = __webpack_public_path__ + "static/media/healing-frequencies.22ec328d.png";